"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _indexWeex = require("weex-bindingx/lib/index.weex.js");

var _indexWeex2 = _interopRequireDefault(_indexWeex);

var _utils = require("../utils");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animation = weex.requireModule("animation"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    data: {
      type: Array,
      default: []
    },
    height: {
      type: Number,
      default: 90
    },
    styles: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      mobileX: 0,
      webStarX: 0,
      saveIdx: null,
      isAndroid: _utils2.default.env.isAndroid()
    };
  },

  methods: {
    special: function special(dom, styles) {
      animation.transition(dom, {
        styles: styles,
        duration: 200, //ms
        timingFunction: "ease",
        delay: 100 //ms
      });
    },
    onRightNode: function onRightNode(pNode, node, i) {
      node.onPress();
      if (pNode.autoClose) this.special(this.$refs.skid[i], {
        transform: "translate(0, 0)"
      });
    },
    onNodeClick: function onNodeClick(node, i) {
      if (this.mobileX < 0) {
        this.mobileX = 0;
        this.special(this.$refs.skid[this.saveIdx], {
          transform: "translate(0, 0)"
        });
        this.isAndroid && this.special(this.$refs.skid[i], {
          transform: "translate(0, 0)"
        });
      } else {
        this.$emit("onNodeClick", node, i);
      }
    },
    onPanEnd: function onPanEnd(e, node, i) {
      if (_utils2.default.env.isWeb()) {
        var webEndX = e.changedTouches[0].pageX;
        this.movingDistance(webEndX - this.webStarX, node, this.$refs.skid[i]);
      }
    },

    onPanStart: function onPanStart(e, node, i) {
      var saveIdx = this.saveIdx;

      if (saveIdx !== i && saveIdx !== null) {
        this.special(this.$refs.skid[saveIdx], {
          transform: "translate(0, 0)"
        });
        this.mobileX = 0;
      }
      this.saveIdx = i;
      !_utils2.default.env.isWeb() ? this.mobile(e, node, i) : this.web(e, node, i);
      e.stopPropagation();
    },
    web: function web(e, node, i) {
      this.webStarX = e.changedTouches[0].pageX;
    },
    mobile: function mobile(e, node, i) {
      var _this = this;

      var el = this.$refs["skid"][i];
      _indexWeex2.default.bind({
        anchor: el.ref,
        eventType: "pan",
        props: [{
          element: el.ref,
          property: "transform.translateX",
          expression: "x+" + (this.isAndroid ? 0 : this.mobileX)
        }]
      }, function (e) {
        var state = e.state,
            deltaX = e.deltaX;

        if (state === "end") {
          _this.mobileX += deltaX;
          _this.movingDistance(_this.mobileX, node, el);
        }
      });
    },
    movingDistance: function movingDistance(scope, node, el) {
      var len = node.right ? node.right.length : 0;
      var distance = len * -100;
      if (scope < -30) {
        this.special(el, {
          transform: "translate(" + distance + "px, 0)"
        });
        this.mobileX = distance;
      } else {
        this.special(el, {
          transform: "translate(0, 0)"
        });
        this.mobileX = 0;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/wxc-swipe-action/index.vue
// module id = 152
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34